/**
 * TitleStrategy Befret (#600) — titre d'onglet par route.
 *
 * Avant #600, tous les onglets navigateur s'appelaient pareil (le <title>
 * statique d'index.html). Compose désormais :
 *   « <titre de route> — Befret<suffixe env> »
 * - titre de route : `title:` de la route la plus profonde qui en déclare un ;
 *   à défaut, dernier segment d'URL lisible (segments techniques ignorés).
 * - suffixe env : ' DEV' / ' ACC' (rien en prod) — un onglet acceptance ne
 *   ressemble jamais à un onglet production.
 */

import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { getEnvInfo } from './utils/env-info';

@Injectable({ providedIn: 'root' })
export class BefretTitleStrategy extends TitleStrategy {

  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const routeTitle = this.buildTitle(snapshot) || this.titleFromUrl(snapshot.url);
    const suffix = `Befret${getEnvInfo().titleSuffix}`;
    this.title.setTitle(routeTitle ? `${routeTitle} — ${suffix}` : suffix);
  }

  /** Fallback : humanise le dernier segment d'URL parlant (ignore ids et query). */
  private titleFromUrl(url: string): string {
    const segments = (url.split('?')[0] || '')
      .split('/')
      .filter(s => s && !/^\d+$/.test(s) && !/^[A-Za-z0-9_-]{18,}$/.test(s)); // ids Firestore/numériques
    const last = segments[segments.length - 1] || '';
    if (!last || last === 'backoffice') return segments[0] === 'backoffice' ? 'Backoffice' : '';
    return decodeURIComponent(last)
      .replace(/[-_]/g, ' ')
      .replace(/^\w/, c => c.toUpperCase());
  }
}
